import { Cart, CartItemInput } from "@repo/core";
import { DataLayerEcommerceItem } from "./dataLayer.schema";

export function gtmAddToCartEvent({
  incomingItems,
  cart,
}: {
  incomingItems?: CartItemInput[];
  cart?: Cart;
}) {
  if (typeof window === "undefined") {
    return;
  }

  if (!incomingItems || incomingItems.length === 0) {
    console.info(
      "gtmAddToCartEvent - incomingItems is empty skipping gtmAddToCartEvent",
    );
    return;
  }

  if (!cart || cart.items.length === 0) {
    console.info(
      "gtmAddToCartEvent - cart is empty skipping gtmAddToCartEvent",
    );
    return;
  }

  window.dataLayer = window.dataLayer || [];

  const items: DataLayerEcommerceItem[] = incomingItems.map((item) => {
    const foundExistingItem = cart?.items.find(
      ({ partNo }) => partNo === item.partNo,
    );

    if (!foundExistingItem) {
      return {
        item_id: item.partNo,
        quantity: item.quantity,
        price: 0,
      };
    }

    return {
      item_id: foundExistingItem.partNo,
      item_name: foundExistingItem.name,
      item_brand: foundExistingItem.extras?.brand,
      item_variant: foundExistingItem.extras?.variant,
      price: foundExistingItem.price,
      quantity: item.quantity,
      currency: cart?.currencyCode,
    };
  });

  const totalPrice = items.reduce(
    (a, b) => a + (b.price ?? 0) * (b.quantity ?? 0),
    0,
  );

  window.dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      currency: cart?.currencyCode,
      value: totalPrice,
      items,
    },
  });
}
